import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import ModalBody from "./ModalBody";
import ModalHeader from "./ModalHeader";
import useCsvUpload from "../../hooks/useCsvUpload";
function UploadCSVModal() {
  // this should be part of a custom hook
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.showCsvUploadModal
      };
    }),
    isVisible = _useStoreState.isVisible;
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    dispatch = _useCsvUpload2[1];
  function closeModal() {
    // this should be part of a custom hook
    Store.update(function (s) {
      s.showCsvUploadModal = false;
    });
    dispatch({
      type: "reset"
    });
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    closeOnClickAway: true,
    className: "w-full sm:w-10/12 xl:w-1/2 3xl:w-5/12 sm:!bg-gray-200 !bg-gray-900 sm:dark:!bg-gray-800 h-[80%] flex flex-col sm:h-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    onClose: closeModal
  }), /*#__PURE__*/React.createElement(ModalBody, null)));
}
export default UploadCSVModal;